import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addProduct } from "../../../redux/productSlice";
import ExcelUpload from "./ExcelUpload";
import { toast } from "react-toastify";

const AddProduct = () => {
  const dispatch = useDispatch();
  const [product, setProduct] = useState({
    name: "",
    mrpPrice: "",
    price: "",
    stock: 0,
    description: "",
    category: "",
    images: [],
  });
  if (process.env.NODE_ENV === "development") {
    console.log("product", product);
  }
  const categories = ["Electronics", "Jewellery", "Clothing", "Home Appliances", "Books", "Toys"];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProduct({ ...product, [name]: value });
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setProduct({ ...product, images: files });
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.entries(product).forEach(([key, value]) => {
      if (key === "images") {
        value.forEach((img) => data.append("images", img));
      } else {
        data.append(key, value);
      }
    });

    const res = await dispatch(addProduct(data));
    if (res.error) {
      toast.error(res.error.message);
    } else {
      toast.success("Product added successfully!");
      setProduct({ name: "", mrpPrice: "", price: "", images: [], stock: 0, description: "", category: "" });
    }
  };

  useEffect(() => {
    return () => {
      product.images.forEach((img) => {
        if (img instanceof File) {
          URL.revokeObjectURL(img);
        }
      });
    };
  }, [product.images]);

  return (
    <Container>
      <Row className="justify-content-md-center">
        <Col lg={12}>
          <h1 className="text-center">Add Product</h1>
        </Col>
        <Col md={3}>
          <Card className="p-3 bg-white rounded shadow-sm">
            <Link to="/my/profile" className="text-decoration-none">Profile</Link>
            <Link to="/my/order" className="text-decoration-none">Order</Link>
          </Card>
        </Col>
        <Col lg={9}>

          <Form onSubmit={handleSubmit}>
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3" controlId="formName">
                  <Form.Label>Product Name</Form.Label>
                  <Form.Control type="text" name="name" value={product.name} onChange={handleChange} required />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3" controlId="formMrpPrice">
                  <Form.Label>MRP Price</Form.Label>
                  <Form.Control type="number" name="mrpPrice" value={product.mrpPrice} onChange={handleChange} required />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3" controlId="formPrice">
                  <Form.Label>Price</Form.Label>
                  <Form.Control type="number" name="price" value={product.price} onChange={handleChange} required />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3" controlId="formStock">
                  <Form.Label>Stock</Form.Label>
                  <Form.Control type="number" name="stock" value={product.stock} onChange={handleChange} required min="0" />
                </Form.Group>
              </Col>

              <Col md={8}>
                <Form.Group className="mb-3" controlId="formImages">
                  <Form.Label>Upload Images</Form.Label>
                  <Form.Control type="file" multiple onChange={handleImageChange} />
                </Form.Group>
              </Col>

              <Col md={4}>
                <Form.Group className="mb-3" controlId="formCategory">
                  <Form.Label>Category</Form.Label>
                  <Form.Select name="category" value={product.category} onChange={handleChange} required>
                    <option value="">Select a category</option>
                    {categories.map((cat, index) => (
                      <option key={index} value={cat}>{cat}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={12}>
                {product.images.length > 0 &&
                  product.images.map((img, index) => (
                    <Col key={index} md={3}>
                      <Card>
                        <Card.Img
                          variant="top"
                          src={img instanceof File ? URL.createObjectURL(img) : img} // Ensure it's a File before creating an object URL
                          alt="Preview"
                        />
                      </Card>
                    </Col>
                  ))}
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3" controlId="formDescription">
                  <Form.Label>Description</Form.Label>
                  <Form.Control as="textarea" rows={3} name="description" value={product.description} onChange={handleChange} required />
                </Form.Group>
              </Col>
              <Col lg={12}>
                <Button variant="primary" type="submit" className="w-100">
                  Add Product
                </Button>
              </Col>
            </Row>

          </Form>
        </Col>
      </Row >
      <Row>
        <Col lg={12}>
          <ExcelUpload />
        </Col>
      </Row>
    </Container >
  );
};

export default AddProduct;
